module.exports = __webpack_public_path__ + "img/40_38_090_300.31318664.jpg";